export default function ContactMe() {
  return (
    <section id="Contact" className="contact--section">
      <div className="skills--section--heading">CONTACT US</div>
      <div className="contact--content">
        <div className="contact-info-box">
          <p>
            #111-19289 Langley Bypass
            <br />
            Surrey, BC V3S 6K1
            <br />
            <a
              href="tel:+17782387305"
              target="_blank"
              rel="noreferrer"
              className="contact--link"
            >
              778-238-7305
            </a>
            <br />
            <a
              href="mailto:westcoastautodetailingservices@gmail.com"
              target="_blank"
              rel="noreferrer"
              className="contact--link"
            >
              westcoastautodetailingservices@gmail.com
            </a>
            <br />
            <br />
            <a
              href="https://www.instagram.com/westcoastautodetailing_/"
              className="navbar--content"
              target="_blank"
              rel="noreferrer"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 33 33"
                fill="none"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M22.0001 4.65479H11.3334C7.65152 4.65479 4.66675 7.63956 4.66675 11.3215V21.9881C4.66675 25.67 7.65152 28.6548 11.3334 28.6548H22.0001C25.6819 28.6548 28.6667 25.67 28.6667 21.9881V11.3215C28.6667 7.63956 25.6819 4.65479 22.0001 4.65479ZM26.3334 21.9881C26.3261 24.3783 24.3902 26.3141 22.0001 26.3215H11.3334C8.94321 26.3141 7.0074 24.3783 7.00008 21.9881V11.3215C7.0074 8.93125 8.94321 6.99544 11.3334 6.98812H22.0001C24.3902 6.99544 26.3261 8.93125 26.3334 11.3215V21.9881ZM23.0001 11.6548C23.7365 11.6548 24.3334 11.0578 24.3334 10.3215C24.3334 9.58508 23.7365 8.98812 23.0001 8.98812C22.2637 8.98812 21.6667 9.58508 21.6667 10.3215C21.6667 11.0578 22.2637 11.6548 23.0001 11.6548ZM16.6667 10.6548C13.353 10.6548 10.6667 13.3411 10.6667 16.6548C10.6667 19.9685 13.353 22.6548 16.6667 22.6548C19.9805 22.6548 22.6667 19.9685 22.6667 16.6548C22.6703 15.0624 22.0393 13.5342 20.9133 12.4082C19.7873 11.2822 18.2591 10.6512 16.6667 10.6548ZM13.0001 16.6548C13.0001 18.6799 14.6417 20.3215 16.6667 20.3215C18.6918 20.3215 20.3334 18.6799 20.3334 16.6548C20.3334 14.6297 18.6918 12.9881 16.6667 12.9881C14.6417 12.9881 13.0001 14.6297 13.0001 16.6548Z"
                  fill="black"
                />
              </svg>
              @westcoastautodetailing_
            </a>
          </p>
        </div>
        {/* <div className="contact-form-section">
          <form className="contact--form--container">
            <p className="text-lg">
              Book a consult, get a quote, or learn more about us!
            </p>
            <div className="container">
              <label htmlFor="first-name" className="contact--label">
                <span className="text-md">First Name</span>
                <input
                  type="text"
                  className="contact--input text-md"
                  name="first-name"
                  id="first-name"
                  required
                />
              </label>
              <label htmlFor="last-name" className="contact--label">
                <span className="text-md">Last Name</span>
                <input
                  type="text"
                  className="contact--input text-md"
                  name="last-name"
                  id="last-name"
                  required
                />
              </label>
              <label htmlFor="email" className="contact--label">
                <span className="text-md">Email</span>
                <input
                  type="email"
                  className="contact--input text-md"
                  name="email"
                  id="email"
                  required
                />
              </label>
              <label htmlFor="phone-number" className="contact--label">
                <span className="text-md">Phone Number</span>
                <input
                  type="number"
                  className="contact--input text-md"
                  name="phone-number"
                  id="phone-number"
                  required
                />
              </label>
            </div>
            <div className="bottom--container">
              <label htmlFor="message" className="contact--label">
                <span className="text-md">Message</span>
                <textarea
                  className="contact--input text-md"
                  id="message"
                  cols="30"
                  rows="8"
                  placeholder="Type your message..."
                />
              </label>
              <div className="contact--form--btn--container">
                <button className="btn btn-primary contact--form--btn">
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div> */}
      </div>
    </section>
  );
}
